import axios from "axios";

export default {
  state: {
    stagioni_coltivazione: [],
    tipi_stagione: [],
    contenitori_coltivazione: [],
    prodotti_pianificazione: {},
    riepilogo_posizionamento: {},
  },
  getters: {
    getStagioniColtivazione(state) {
      return state.stagioni_coltivazione;
    },
    getTipiStagione(state) {
      return state.tipi_stagione;
    },
    getContenitoriColtivazione(state) {
      return state.contenitori_coltivazione;
    },
    getProdottiPianificazione(state) {
      return (id_stagione) => state.prodotti_pianificazione[id_stagione] || [];
    },
    getRiepilogoPosizionamento(state) {
      return (id_stagione) => state.riepilogo_posizionamento[id_stagione] || [];
    },
  },
  mutations: {
    setStagioniColtivazione(state, stagioni) {
      state.stagioni_coltivazione = stagioni;
    },
    addStagioniColtivazione(state, stagione) {
      state.stagioni_coltivazione.push(stagione);
    },
    setTipiStagione(state, tipi) {
      state.tipi_stagione = tipi;
    },
    addTipoStagione(state, tipo) {
      state.tipi_stagione.push(tipo);
    },
    updateTipoStagione(state, tipo) {
      state.tipi_stagione = state.tipi_stagione.map((t) =>
        t.id === tipo.id ? tipo : t,
      );
    },
    removeTipoStagione(state, id) {
      state.tipi_stagione = state.tipi_stagione.filter((t) => t.id !== id);
    },
    setContenitoriColtivazione(state, contenitori) {
      state.contenitori_coltivazione = contenitori;
    },
    addContenitoreColtivazione(state, contenitore) {
      state.contenitori_coltivazione.push(contenitore);
    },
    removeContenitoreColtivazione(state, id_contenitore) {
      state.contenitori_coltivazione = state.contenitori_coltivazione.filter(
        (contenitore) => contenitore.id !== id_contenitore,
      );
    },
    setProdottiPianificazione(state, { id_stagione, prodotti }) {
      state.prodotti_pianificazione = {
        ...state.prodotti_pianificazione,
        [id_stagione]: prodotti,
      };
    },
    addProdottoPianificazione(state, prodotto) {
      const id = prodotto.id_stagione;
      const lista = state.prodotti_pianificazione[id] || [];
      state.prodotti_pianificazione = {
        ...state.prodotti_pianificazione,
        [id]: [...lista, prodotto],
      };
    },
    removeProdottoPianificazione(state, { id_stagione, id_prodotto }) {
      const lista = state.prodotti_pianificazione[id_stagione] || [];
      state.prodotti_pianificazione = {
        ...state.prodotti_pianificazione,
        [id_stagione]: lista.filter((p) => p.id !== id_prodotto),
      };
    },
    updateProdottoPianificazione(state, prodotto) {
      const id = prodotto.id_stagione;
      const lista = state.prodotti_pianificazione[id] || [];
      state.prodotti_pianificazione = {
        ...state.prodotti_pianificazione,
        [id]: lista.map((p) => (p.id === prodotto.id ? prodotto : p)),
      };
    },
    updateContenitoreColtivazione(state, contenitore) {
      state.contenitori_coltivazione = state.contenitori_coltivazione.map(
        (c) => (c.id === contenitore.id ? contenitore : c),
      );
    },
    setRiepilogoPosizionamento(state, { id_stagione, data }) {
      state.riepilogo_posizionamento = { ...state.riepilogo_posizionamento, [id_stagione]: data };
    },
    removeStagioneColtivazione(state, id) {
      state.stagioni_coltivazione = state.stagioni_coltivazione.filter((s) => s.id !== id);
      // eslint-disable-next-line no-unused-vars
      const { [id]: _dropped, ...rest } = state.prodotti_pianificazione;
      state.prodotti_pianificazione = rest;
    },
  },
  actions: {
    fetchStagioniColtivazione({ commit }) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/stagioni";
      let auth = this.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth: auth })
          .then((response) => {
            commit("setStagioniColtivazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.error(
              "Errore nel recupero delle stagioni di coltivazione:",
              error,
            );
            reject(error);
          }),
      );
    },
    saveStagione(context, stagione) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/stagione";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, stagione, { auth: auth })
          .then((response) => {
            context.commit("addStagioniColtivazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchRiepilogoPosizionamento(context, id_stagione) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/stagione/${id_stagione}/riepilogo_posizionamento`;
      return axios.get(url, { auth: context.getters.get_credential }).then((response) => {
        context.commit('setRiepilogoPosizionamento', { id_stagione, data: response.data });
        return response.data;
      });
    },
    deleteStagioneColtivazione(context, { id, dry_run = false }) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/piano_coltivazione/stagione/${id}${dry_run ? '?dry_run=true' : ''}`;
      return axios.delete(url, { auth: context.getters.get_credential }).then((response) => {
        if (!dry_run) context.commit('removeStagioneColtivazione', id);
        return response.data;
      });
    },
    fetchContenitoriColtivazione({ commit }) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/contenitori";
      let auth = this.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth: auth })
          .then((response) => {
            commit("setContenitoriColtivazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.error(
              "Errore nel recupero dei contenitori di coltivazione:",
              error,
            );
            reject(error);
          }),
      );
    },
    saveContenitoreColtivazione(context, contenitore) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/contenitore";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, contenitore, { auth: auth })
          .then((response) => {
            context.commit("addContenitoreColtivazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    saveProdottoPianificazione(context, payload) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/prodotto";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .post(url, payload, { auth: auth })
          .then((response) => {
            context.commit("addProdottoPianificazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchProdottiPianificazione(context, id_stagione) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/stagione/" +
        id_stagione +
        "/prodotti";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth: auth })
          .then((response) => {
            context.commit("setProdottiPianificazione", {
              id_stagione,
              prodotti: response.data,
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
    deleteProdottoPianificazione(context, { id_stagione, id_prodotto }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/prodotto/" +
        id_prodotto;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, { auth: auth })
          .then((response) => {
            context.commit("removeProdottoPianificazione", {
              id_stagione,
              id_prodotto,
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteContenitoreColtivazione(context, id_contenitore) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/contenitore/" +
        id_contenitore;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .delete(url, { auth: auth })
          .then((response) => {
            context.commit("removeContenitoreColtivazione", id_contenitore);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateProdottoPianificazione(context, { id_stagione, id_prodotto, payload }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/prodotto/" +
        id_prodotto;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, payload, { auth: auth })
          .then((response) => {
            context.commit("updateProdottoPianificazione", {
              ...response.data,
              id_stagione,
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateContenitoreColtivazione(context, { id_contenitore, payload }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/contenitore/" +
        id_contenitore;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) => {
        axios
          .put(url, payload, { auth: auth })
          .then((response) => {
            context.commit("updateContenitoreColtivazione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchTipiStagione({ commit }) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/tipi_stagione";
      let auth = this.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .get(url, { auth: auth })
          .then((response) => {
            commit("setTipiStagione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
    saveTipoStagione(context, tipo) {
      let url =
        process.env.VUE_APP_API_ROOT + "/admin/piano_coltivazione/tipi_stagione";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .post(url, tipo, { auth: auth })
          .then((response) => {
            context.commit("addTipoStagione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
    updateTipoStagione(context, { id, payload }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/tipi_stagione/" +
        id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .put(url, payload, { auth: auth })
          .then((response) => {
            context.commit("updateTipoStagione", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
    linkProdottoCommerciale(context, { id_stagione, id_prodotto, id_prodotto_commerciale }) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/prodotto/" +
        id_prodotto +
        "/prodotto-commerciale";
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .put(url, { id_prodotto_commerciale }, { auth })
          .then((response) => {
            context.commit("updateProdottoPianificazione", {
              ...response.data,
              id_stagione,
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
    deleteTipoStagione(context, id) {
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/piano_coltivazione/tipi_stagione/" +
        id;
      let auth = context.getters.get_credential;
      return new Promise((resolve, reject) =>
        axios
          .delete(url, { auth: auth })
          .then((response) => {
            context.commit("removeTipoStagione", id);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          }),
      );
    },
  },
};
